import { observer } from "mobx-react";
import { styled } from "@mui/material";
import { Box } from "@mui/system";

import { useInject } from "@utilifeed/hooks";
import { DRAWER_WIDTH } from "@config/ui_constants";

type StyledDrawerType = {
  open: boolean;
  isSideNavOpen: boolean;
};

type PersistentDrawerType = {
  open: boolean;
  children: JSX.Element | JSX.Element[];
};

const StyledDrawer = styled(Box, {
  shouldForwardProp: (propName) => propName !== "isSideNavOpen",
})<StyledDrawerType>(({ theme, open, isSideNavOpen }) => ({
  position: "absolute",
  height: "100vh",
  backgroundColor: theme.palette.background.paper,
  width: open ? `calc(100vw - ${isSideNavOpen ? DRAWER_WIDTH : 0}px)` : 0,
  transition: "all 0.15s ease-in-out",
  overflow: "auto",
  zIndex: 1150,
  top: 0,
  right: 0,
}));

function PersistentDrawer({ open, children }: PersistentDrawerType) {
  const { ui } = useInject("ui");

  const isSideNavOpen = [
    ui.is_cluster_detail_open,
    ui.is_cluster_model_open,
    ui.is_cluster_summary_open,
    ui.is_editfilters_open,
    ui.is_filteroptions_open,
    ui.is_sidenav_open,
    ui.is_subdetail_open,
    ui.is_substation_model_open,
    ui.is_subsummary_open,
  ].includes(true);

  return (
    <StyledDrawer open={open} isSideNavOpen={isSideNavOpen} id="persistent-drawer">
      {open && children}
    </StyledDrawer>
  );
}

export default observer(PersistentDrawer);
